import {
  BaseContextT,
  createAppContext,
  createAppHook,
  createAppProvider,
  createProviderConfig,
  useBaseContext,
} from '@/providers/components/baseProvider';

// Config
const {table, columns, statsView} = createProviderConfig({
  table: 'Admin',
  columns: [
    'admin_id',
    'is_active',
    'role',
    [
      'Speculator',
      ['speculator_id', 'speculator_username', 'speculator_name_first', 'speculator_name_last', 'speculator_city'],
    ],
  ],
  statsView: 'admin_stats',
});

type TableT = typeof table;
type ColumnsT = typeof columns;
type StatsViewT = typeof statsView;
type CustomContextT = Record<string, unknown>;

// Context
type AdminsContextT = BaseContextT<TableT, StatsViewT, ColumnsT, CustomContextT>;
const AdminsContext = createAppContext<AdminsContextT>(table);

// Provider
const ContextProvider = ({children}: {children: React.ReactNode}) => {
  const baseContext = useBaseContext<TableT, ColumnsT, StatsViewT>();

  // Custom state, functions, etc...

  return (
    <AdminsContext.Provider
      value={{
        ...baseContext,
        // ...add custom stuff here...
      }}
    >
      {children}
    </AdminsContext.Provider>
  );
};

// Add this to the AppProviders.tsx file
export const AdminsProvider = createAppProvider({
  table,
  columns,
  statsView,
  ContextProvider,
});

// Hook
export const useAdmins = createAppHook<TableT, StatsViewT, ColumnsT, CustomContextT>(AdminsContext);
